import { client } from "../net/client";
import { fa } from "./cards";
import { unitName } from "./watching";
import { Overlay } from "../ui/Overlay";
import { CupAfter, useCupNext } from "../ui/CupBits";
import { ResultAd } from "../ui/Ads";

/**
 * پایانِ مسابقه.
 *
 * بی این، میزِ تمام‌شده روی صفحه می‌مانْد و بازیکن راهی جز دکمه‌ی «بیرون» نداشت —
 * که مثلِ فرار از میز به نظر می‌رسد، نه پایانِ بازی.
 */
/**
 * `lowestWins`: در هفت خبیث امتیاز جریمه است، پس برنده کم‌ترین امتیاز را دارد —
 * برعکسِ حکم و چهاربرگ. بی این پرچم، بازنده «بردی!» می‌دید.
 */
export function MatchOver({ score, me, units, lowestWins = false, watching = false }:
  { score: number[]; me: number; units: number; lowestWins?: boolean; watching?: boolean }) {
  const mine = units > 0 ? me % units : 0;
  const best = score.indexOf(lowestWins ? Math.min(...score) : Math.max(...score));
  const won = best === mine;
  // میزِ جام: نتیجه‌ی جام و «بازیِ بعدی در جام» کارِ اصلی‌اند و برگشت کم‌رنگ می‌شود.
  const cupNext = useCupNext() && !watching;
  return (
    <Overlay label="پایان مسابقه" card={watching ? "even" : won ? "win" : "lose"}
             after={<ResultAd won={watching ? null : won} watching={watching} />}>
      <div className="vt">
        {watching ? `${unitName(best, units < 4)} بُرد` : won ? "بردی!" : "باختی"}
      </div>
      <div className="muted vscore">{score.map(fa).join("  -  ")}</div>
      {!watching && <CupAfter />}
      <button className={cupNext ? "btn ghost" : "btn"} style={{ maxWidth: 260 }} onClick={() => client.exitTable()}>
        {watching ? "پایان تماشا" : "بازگشت به لابی"}
      </button>
    </Overlay>
  );
}
